import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TextMaskModule } from 'angular2-text-mask';

import { DynamicTranslationModule } from '../../dynamic-translation/dynamic-translation.module';
import { ActionButtonModule } from '../action-button/action-button.module';
import { TableModule } from '../table/table.module';
import { ShiftSettingsComponent } from './shift-settings.component';
import { ShiftSettingsService } from './shift-settings.service';
import { effects } from './store/effects';
import { reducers } from './store/reducers';

@NgModule({
  imports: [
    DynamicTranslationModule,
    CommonModule,
    FormsModule,
    TextMaskModule,
    TableModule,
    ActionButtonModule,
    StoreModule.forFeature('shiftSettings', reducers),
    EffectsModule.forFeature(effects)
  ],
  declarations: [ShiftSettingsComponent],
  exports: [ShiftSettingsComponent],
  providers: [ShiftSettingsService]
})
export class ShiftSettingsModule {}
